import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';

const Panel = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="panel"
    className={cn('tw:rounded-lg tw:bg-white tw:shadow-md', className)}
    {...props}
  />
));
Panel.displayName = 'Panel';

export { Panel };
